import { Brand } from "@/components/Brand";

export default function AuthShell({ children }) {
  return (
    <div className="min-h-screen bg-[var(--paper)] flex flex-col">
      <header className="bg-[var(--navy)]"><div className="max-w-5xl mx-auto px-6 h-16 flex items-center"><Brand light /></div><div className="h-1 bg-[var(--red)]" /></header>
      <main className="flex-1 flex justify-center px-4 py-12">
        <div className="tile w-full max-w-xl h-fit fade-up"><div className="p-8">{children}</div></div>
      </main>
    </div>
  );
}
